export default __webpack_public_path__ + "static/media/1556.3286a30b.png";